import { useState } from "react";
import { ArrowRight, Check, Calendar, Clock } from "lucide-react";
import { cdnPath } from "@/utility/api";

const ProgramCard = ({ cohort, data }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleNavigation = (link) => {
    window.location.href = link;
  };

  const handledivclick = (id) => {
    if (id === 104) {
      window.location.href = "/internship-cohort";
    }
    if (id === 106) {
      window.location.href = "/hr-fellowship";
    }
    if (id === 107) {
      window.location.href = "/articleship-cohort";
    }
    if (id === 108) {
      window.location.href = "/placement-cohort";
    }
  };

  return (
    <div
      className="relative overflow-hidden bg-[#0f1117] rounded-2xl shadow-lg border border-gray-800 hover:border-[#a78bfa]/50 transition-all duration-500 h-full flex flex-col cursor-pointer"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => handledivclick(cohort?.id)}
    >
      {/* Image container with proper aspect ratio */}
      <div className="relative w-full pt-[56.25%] overflow-hidden">
        {" "}
        {/* 16:9 aspect ratio */}
        <div
          className={`absolute inset-0 transition-transform duration-700 ${
            isHovered ? "scale-110" : "scale-100"
          }`}
          style={{
            backgroundImage: `url(${cdnPath}/${cohort.image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            width: "100%",
            height: "100%",
          }}
        ></div>
        {/* Background gradient overlay */}
        <div className="absolute inset-x-0 bottom-0 h-12 bg-gradient-to-t from-[#0f1117]/40 to-transparent z-10"></div>
      </div>

      {/* Content */}
      <div className="relative z-20 p-6 flex-grow flex flex-col">
        {/* Tags - Moved above title */}
        <div className="flex flex-wrap gap-2 mb-4">
          {cohort.tags.map((tag) => (
            <span
              key={tag.name}
              className={`${tag.color} px-3 py-1 rounded-full text-xs font-semibold`}
            >
              {tag.name}
            </span>
          ))}
        </div>

        {/* Title */}
        <h2 className=" text-xl md:text-3xl font-bold text-white mb-2 tracking-tight">
          {cohort.title}
        </h2>

        {/* Subtitle if available */}
        {/* {cohort.subtitle && (
          <h3 className="text-md md:text-lg font-medium text-[#a78bfa] mb-4">
            {cohort.subtitle}
          </h3>
        )} */}

        {/* Description */}
        <p className="text-gray-300 mb-6">{cohort.description}</p>

        {/* Program details */}
        <div className="grid grid-cols-2 gap-4 mb-6">
          <div className="flex items-center gap-2">
            <Clock className="w-5 h-5 text-[#a78bfa]" />

            <span className="text-gray-200">{data?.duration} weeks</span>
          </div>
          <div className="flex items-center gap-2">
            <Calendar className="w-5 h-5 text-[#a78bfa]" />

            {cohort?.id === 104 || cohort?.id === 108 ? (
              <span className="text-gray-200">
                Enroll and Begin Immediately
              </span>
            ) : (
              <span className="text-gray-200">Starts {data?.startDate}</span>
            )}
          </div>
        </div>

        {/* Features */}
        <div className="mb-6">
          <h4 className="text-lg font-semibold text-white mb-3">
            What you'll learn:
          </h4>
          <ul className="space-y-2">
            {cohort.features
              .slice(0, cohort.features.length)
              .map((feature, index) => (
                <li key={index} className="flex items-start gap-2">
                  <Check className="w-5 h-5 text-[#a78bfa] mt-0.5 flex-shrink-0" />
                  <span className="text-gray-300">{feature}</span>
                </li>
              ))}
          </ul>
        </div>

        {/* Stats */}
        {/* <div className="grid grid-cols-3 gap-2 mb-6">
          {cohort.stats.map((stat, index) => (
            <div key={index} className="text-center">
              <p className="text-2xl font-bold text-[#a78bfa]">{stat.value}</p>
              <p className="text-xs text-gray-400">{stat.label}</p>
            </div>
          ))}
        </div> */}

        {/* Spacer to push button to bottom */}
        <div className="flex-grow"></div>

        {/* Price and CTA Button - Fixed at bottom */}
        <div className="relative z-20 pt-4">
          {/* Price */}
          <div className="flex items-center gap-3 mb-4">
            <span className="text-2xl font-bold text-white">
              ₹{data?.discountedPrice}
            </span>
            {data?.discountedPrice && (
              <span className="text-lg text-gray-400 line-through">
                ₹{data.discountedPrice + 1000}
              </span>
            )}
            <span className="bg-[#a78bfa]/20 text-[#a78bfa] text-xs px-2 py-1 rounded-full">
              Limited Time Offer
            </span>
          </div>

          {/* CTA Button */}
          <button
            onClick={() => handleNavigation(cohort.link)}
            className="w-full py-3 bg-[#a78bfa] hover:bg-[#9061f9] text-white rounded-xl transition-all duration-300 flex items-center justify-center gap-2 text-lg font-semibold group"
          >
            {cohort.cta}
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProgramCard;
